import {Component, Input} from '@angular/core';

/**
 * navItem "Storno" of the Provisionssatz OBC, widget alias `cp.contractAgent.cancellation`.
 *
 * The terminal state of a Provisionssatz: the effective (frozen) `cancellationDate` and the
 * `cancellationLiabilityAmount`, i.e. the amount that was still in liability at that date. Both
 * stay empty on a row that was never cancelled — and that empty state is the TRUTH here, not an
 * outstanding calculation, so neither field takes the FD-7(a) pending hint.
 */
@Component({
    selector: 'cp-provision-contract-agent-cancellation',
    templateUrl: './cp-provision-contract-agent-cancellation.component.html',
    styleUrls: ['./cp-provision-contract-agent-cancellation.component.scss'],
    standalone: false
})
export class CpProvisionContractAgentCancellationComponent {

    @Input() provisionContractAgentId: number;

    /** Fields per row — the side view passes 1. */
    @Input() columns: number = 2;

    readonly fields: string[] = [
        'cancellationDate',
        'cancellationLiabilityAmount'
    ];

}
